var _path, _g, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyPopper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38743_138586",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 22,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10029 25.5L11.0003 8L24.0003 21L6.50029 27.9C5.00029 28.4 3.60029 27 4.10029 25.5Z",
    fill: "#FFB200"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38743_138586)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 20,
    height: 20,
    fill: "#FFB200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95156 10.0426L5.97168 12.0225L19.4773 25.5281L21.4572 23.5482L7.95156 10.0426Z",
    fill: "#BE58FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92666 18.0172L3.94678 19.9971L12.432 28.4823L14.4119 26.5024L5.92666 18.0172Z",
    fill: "#BE58FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0998 14.3002C17.8998 14.0002 16.9998 11.0002 18.5998 9.10023C19.2998 8.20023 20.4998 7.80023 21.9998 7.80023C21.9998 7.10023 22.1998 6.00023 23.0998 5.10023C24.1998 4.00023 25.8998 3.60023 28.1998 4.00023L27.8998 6.00023C26.7998 5.80023 25.2998 5.80023 24.5998 6.50023C23.6998 7.30023 23.9998 8.80023 23.9998 8.80023L24.2998 10.2002L22.7998 10.0002C21.8998 9.80023 20.5998 9.80023 20.0998 10.5002C19.3998 11.3002 19.7998 13.2002 19.8998 13.7002L18.0998 14.3002Z",
    fill: "#FF0800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6998 10.6998L13.2998 9.2998L13.9998 9.9998L13.2998 9.2998C13.4998 9.0998 15.4998 6.8998 13.2998 4.6998L14.6998 3.2998C17.5998 6.1998 15.9998 9.3998 14.6998 10.6998Z",
    fill: "#22B573"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6998 18.7L22.2998 17.3C23.4998 16.1 26.5998 14.2 29.5998 16.2L28.4998 17.9C26.1998 16.3 23.6998 18.7 23.6998 18.7Z",
    fill: "#00C0F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10H26V12H28V10Z",
    fill: "#FF7600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H18V6H20V4Z",
    fill: "#964896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopper);
export default __webpack_public_path__ + "static/media/party_popper.bbdb168aed420b99c2fa1ec362f66845.svg";
export { ForwardRef as ReactComponent };